import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { defaultCardStyle } from '../../Styles';
import { IBaseCardProps } from './BaseCard.types';
import { SrOnlyText } from '../SrOnlyText/SrOnlyText';

const UnstyledBaseCard: FunctionComponent<IBaseCardProps> = props => {
  const { onCardClick, screenReaderText, children, ...otherProps } = props;
  return (
    <button onClick={onCardClick} {...otherProps}>
      {screenReaderText && <SrOnlyText>{screenReaderText}</SrOnlyText>}
      {children}
    </button>
  );
};

export const BaseCard = styled(UnstyledBaseCard)`
  ${defaultCardStyle}
`;

export default BaseCard;
